import getCookie from '../../utils/get-cookie.ts';

export const setupCampaignPhone = () => {
  const campaignPhone = getCookie('sf_campaignPhone');
  if (campaignPhone && campaignPhone !== '') {
    const phoneElements = document.querySelectorAll<HTMLAnchorElement>('.phone-href');
    phoneElements.forEach((phoneElement) => {
      phoneElement.href = `tel:${campaignPhone}`;
      phoneElement.textContent = campaignPhone;
    });
  }
};
